import { environment } from 'src/environments/environment';

/**
 * Overrides createCanonicalURL to update or append a canonical link. It prevents duplicates by checking for an existing link.
 * Adjusts URL for '/busqueda' paths using environment settings for SEO.
 */
function createCanonicalURL(path: string | null = null): void {
  let currentUrl = path ? path : document.URL;

  if (currentUrl.includes('/busqueda')) {
    currentUrl = `${environment.seo.canonicalDomain}`;
  }

  let link: HTMLLinkElement | null = document.head.querySelector(
    "link[rel='canonical']",
  );

  if (link) {
    link.setAttribute('href', currentUrl);
  } else {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', currentUrl);
    document.head.appendChild(link);
  }
}

export default createCanonicalURL;
